//This clears the hamburger menu if the Back button is clicked in the browser
(function () {
window.onpageshow = function(event) {
  if (event.persisted) {
    window.location.reload();
  }
};
})();
//This makes jQuery interactions passive, for better performance
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};
jQuery(document).ready( function() {
  //Add active class to the main navigation
  jQuery('#pursuit_main_nav a.nav-link').filter(function(){
    return this.href === location.href;
  }).addClass('pursuit_active_main_nav');
  //Make top level Bootstrap nav clickable, even with dropdown
  jQuery('#pursuit_main_nav a.dropdown-toggle').on( "click", function() {
    location.href = jQuery(this).attr('href');
  });
  //Keep the active class styles on when hovering inside a dropdown
  jQuery('.dropdown-menu').hover(function(){
    var thisMain = jQuery(this).prev().find('span');
    jQuery(this).prev().find('span').addClass("nav-link__active");
  }, function () {
    jQuery(this).prev().find('span').removeClass("nav-link__active");
  });
  //Hamburger menu opener
  jQuery(".hamburger").on("click touch", function() {
    jQuery(".hamburger").toggleClass("is-active");
    jQuery(".hamMenuBlock").removeClass("hamMenuStart");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockOpen");
    jQuery(".hamMenuBlock").toggleClass("hamMenuBlockClose");
    jQuery("body").toggleClass("scrollStopper");
    if (jQuery(".hamMenuBlock").hasClass("hamMenuBlockClose")) {
      jQuery(".hamMenuBlock").delay(700).queue(function(next){
        jQuery(".hamMenuBlock").addClass("hamMenuStart");;
        next();
      });
    }
  });
  //Hamburger menu sub menus
  jQuery('.hamMenuLinkSubArrow').on('click', function(){
    var thisAnswer = jQuery(this).parent().nextAll('.hamMenuLinkMainSubBlock').first();
    var thisQuestion = jQuery(this).parent();
    jQuery('.hamMenuLinkMainSubBlock').not(thisAnswer).slideUp('fast');
    jQuery(thisAnswer).slideToggle('fast');
    jQuery('.hamMenuLinkSubArrow').parent().not(thisQuestion).removeClass('hamMenuLinkMainActive');
    jQuery(thisQuestion).toggleClass('hamMenuLinkMainActive');
    jQuery('.hamMenuLinkSubArrow').not(this).removeClass('hamMenuLinkSubArrowUp');
    jQuery(this).toggleClass('hamMenuLinkSubArrowUp');
  });

  //Accordion module
  jQuery('.pd_accordionItemTitle').click(function(){
    jQuery(this).attr('aria-expanded', function(index, attr){
      return attr == 'false' ? 'true' : 'false';
    });
    var thisContent = jQuery(this).next('.pd_accordionItemContent');
    jQuery('.pd_accordionItemContent').not(thisContent).slideUp('fast').attr('aria-hidden', 'true');
    jQuery(thisContent).slideToggle('fast').attr('aria-hidden', function(index, attr){
      return attr == 'true' ? 'false' : 'true';
    });
    jQuery('.pd_accordionItemTitle').not(this).removeClass('pd_accordionItemTitleOn').attr('aria-expanded', 'false');
    jQuery(this).toggleClass('pd_accordionItemTitleOn');
  });

  //Sync actions in the Home carousels (image and text)
  jQuery('.carousel-sync.pursuit_home_carousel').on('slide.bs.carousel', function (ev) {
    // get the direction, based on the event which occurs
    var dir = ev.direction == 'right' ? 'prev' : 'next';
    // get synchronized non-sliding carousels, and make'em sliding
    jQuery('.carousel-sync.pursuit_home_carousel').not('.sliding').addClass('sliding').carousel(dir);
  });
  jQuery('.carousel-sync.pursuit_home_carousel').on('slid.bs.carousel', function (ev) {
    // remove .sliding class, to allow the next move
    jQuery('.carousel-sync.pursuit_home_carousel').removeClass('sliding');
  });
  // sync clicks on carousel-indicators as well
  jQuery('.pursuit_home_carousel .carousel-indicators li').click(function (e) {
    e.stopPropagation();
    var goTo = jQuery(this).data('slide-to');
    jQuery('.carousel-sync.pursuit_home_carousel').not('.sliding').addClass('sliding').carousel(goTo);
  });
  // sync the pause on hover
  jQuery( ".carousel-sync.pursuit_home_carousel" ).hover(
    function() {
      jQuery( ".carousel-sync.pursuit_home_carousel" ).carousel('pause');
    }, function() {
      jQuery( ".carousel-sync.pursuit_home_carousel" ).carousel('cycle');
    }
  );

  //Sync actions in the Project Slider carousels (image and text)
  jQuery('.carousel-sync.pursuit_projectslider_carousel').on('slide.bs.carousel', function (ev) {
    // get the direction, based on the event which occurs
    var dir = ev.direction == 'right' ? 'prev' : 'next';
    // get synchronized non-sliding carousels, and make'em sliding
    jQuery('.carousel-sync.pursuit_projectslider_carousel').not('.sliding').addClass('sliding').carousel(dir);
  });
  jQuery('.carousel-sync.pursuit_projectslider_carousel').on('slid.bs.carousel', function (ev) {
    // remove .sliding class, to allow the next move
    jQuery('.carousel-sync.pursuit_projectslider_carousel').removeClass('sliding');
  });
  // sync clicks on carousel-indicators as well
  jQuery('.pursuit_projectslider_carousel .carousel-indicators li').click(function (e) {
    e.stopPropagation();
    var goTo = jQuery(this).data('slide-to');
    jQuery('.carousel-sync.pursuit_projectslider_carousel').not('.sliding').addClass('sliding').carousel(goTo);
  });
  // sync the pause on hover
  jQuery( ".carousel-sync.pursuit_projectslider_carousel" ).hover(
    function() {
      jQuery( ".carousel-sync.pursuit_projectslider_carousel" ).carousel('pause');
    }, function() {
      jQuery( ".carousel-sync.pursuit_projectslider_carousel" ).carousel('cycle');
    }
  );

  //Sync actions in the Listing Slider carousels (image and text)
  jQuery('.carousel-sync.pursuit_listing_carousel').on('slide.bs.carousel', function (ev) {
    // get the direction, based on the event which occurs
    var dir = ev.direction == 'right' ? 'prev' : 'next';
    // get synchronized non-sliding carousels, and make'em sliding
    jQuery('.carousel-sync.pursuit_listing_carousel').not('.sliding').addClass('sliding').carousel(dir);
  });
  jQuery('.carousel-sync.pursuit_listing_carousel').on('slid.bs.carousel', function (ev) {
    // remove .sliding class, to allow the next move
    jQuery('.carousel-sync.pursuit_listing_carousel').removeClass('sliding');
  });
  // sync clicks on carousel-indicators as well
  jQuery('.pursuit_listing_carousel .carousel-indicators li').click(function (e) {
    e.stopPropagation();
    var goTo = jQuery(this).data('slide-to');
    jQuery('.carousel-sync.pursuit_listing_carousel').not('.sliding').addClass('sliding').carousel(goTo);
  });
  // sync the pause on hover
  jQuery( ".carousel-sync.pursuit_listing_carousel" ).hover(
    function() {
      jQuery( ".carousel-sync.pursuit_listing_carousel" ).carousel('pause');
    }, function() {
      jQuery( ".carousel-sync.pursuit_listing_carousel" ).carousel('cycle');
    }
  );
  // add title attribute to all iframe elements
  if (!jQuery('iframe').attr('title')) {
    jQuery('iframe').attr('title', 'Content from Wärtsilä Energy Storage');
  }

  if (window.location.pathname == '/media/') {
    FWP.hooks.addFilter('facetwp/flyout/facets', function(facets) {
      return ['type_media', 'topic', 'area', 'theme'];
    });
  } else if (window.location.pathname == '/resources/') {
    FWP.hooks.addFilter('facetwp/flyout/facets', function(facets) {
      return ['type_resources', 'solution', 'topic', 'application', 'area', 'theme'];
    });
  }

});
